import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICustomerDirectory } from '@dxp/core/models';
import { CustomerApiService } from '@dxp/core/api';

@Injectable({
    providedIn: 'root',
})
export class CustomerDirectoryService {
    readonly #customerApiService = inject(CustomerApiService);

    fetchCustomerDirectory(
        top: number,
        skip: number,
        searchQuery: string | undefined,
        equalsQuery: string | undefined,
        businessUnitId: string | null | undefined,
        requiresName: boolean,
        requiresEmail: boolean,
        requiresPhone: boolean,
        customerId?: string,
    ): Observable<ICustomerDirectory> {
        return this.#customerApiService.getCustomers(
            true,
            ['PhoneNumbers', 'ExternalProfiles', 'CustomFields'],
            'firstName asc, lastName asc',
            skip,
            top,
            {
                businessUnitId,
                requiresEmail,
                requiresName,
                requiresPhone,
            },
            customerId,
            searchQuery,
            equalsQuery,
        );
    }
}
